const $ = jQuery.noConflict();

const tabs = {
    tabWrapper: $('.block-full-page-slider'),
    contentWrapper: $('.block-full-page-slider__content-wrapper'),
    tab(e) {

        let that = e;
        this.tabWrapper.find('active-tab').removeClass('active-tab');
        that.addClass('active-tab');
        let showContent = that.attr('data-item');

        this.contentWrapper.find('.active').removeClass('active');
        this.contentWrapper.find('[data-content =' + showContent + ']').addClass('active');
    },

    init(el) {

        this.tab(el);
    }
}

export default tabs;
